module.exports = __webpack_public_path__ + "static/media/carta_27.0ba08573.jpg";